import React, { useEffect, useState } from "react";
import { Modal, Button, Table, Form } from "react-bootstrap";
import SideBar from "../navigation/sidebar/SideBar";
import NavBar from "../navigation/topnav/NavBar";
import { IoPersonAddSharp } from "react-icons/io5";
import Loader from "../gif/loader.gif";
import axios from "axios";
import RowTitles from "../components/RowTitles";

const Branches = () => {
  const [show, setShow] = useState(false);
  //
  const [name, setName] = useState(null);
  const [postor, setPostor] = useState(null);
  const [address, setAddress] = useState(null);
  const [contact, setContact] = useState(null);
  //
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  //when loggining
  const getBranches = async () => {
    setLoading(!loading);
    try {
      const res = await axios.get(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-branches`
      );
      let retcode = res.data;
      console.log("branches", retcode);
      setBranches(retcode);
      //stop loading
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("get branches error =>" + error);
    }
  };
  const handleSave = async () => {
    let data = {
      name,
      postor,
      address,
      contact,
    };
    try {
      const res = await axios.post(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/save-branch`,
        data
      );
      let retcode = res.data.message;
      //stop loading
      setLoading(false);
      alert(retcode);
      getBranches();
    } catch (error) {
      //stop loading
      setLoading(false);
      alert("Failed creating branh - try again..");
      console.log("post branch error =>" + error);
    }
    // You can save event data here or handle state updates to show it on the calendar
    handleClose();
  };
  useEffect(() => {
    getBranches();
  }, []);
  return (
    <div className="d-flex" style={{ backgroundColor: "#f1f5f7" }}>
      <SideBar />
      {/* Main Content */}
      <div className="flex-grow-1">
        {/* Header */}
        <NavBar />
        <div className="container-fluid mt-4">
          <RowTitles title={"Dashboad"} child={"branches"} />
          <div className="row">
            <div className="col-md-6">
              <h4 className="mb-3">Live branches</h4>
            </div>
            <div className="col-md-6 text-end">
              <button
                onClick={() => handleShow()}
                className="btn  text-black me-2 mt-2 mb-3"
                style={{ borderRadius: 0, backgroundColor: "#3bc0c3" }}
              >
                <IoPersonAddSharp className="me-2" />
                Register branch
              </button>
            </div>
          </div>
          {loading ? (
            <img src={Loader} alt="QR Code" width={"50"} height={"50"} />
          ) : (
            <Table striped bordered hover className="shadow">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Address</th>
                  <th>Postor</th>
                  <th>Contact</th>
                </tr>
              </thead>
              <tbody>
                {branches.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <small>{row.id}</small>
                    </td>
                    <td>
                      <small>{row.name}</small>
                    </td>
                    <td>
                      <small>{row.address}</small>
                    </td>
                    <td>
                      <small>{row.postor}</small>
                    </td>
                    <td>
                      <small>{row.contact}</small>
                    </td>

                    <td>
                      <small className="badg badge-warning">{row.date}</small>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Action Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formEventTitle">
              <Form.Label>
                <small className="text-black">Enter branch name</small>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter branch name"
                value={name}
                style={{ borderRadius: 0 }}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formEventTitle">
              <Form.Label>
                <small className="text-black">Enter branch postor</small>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter branch postor"
                value={postor}
                style={{ borderRadius: 0 }}
                onChange={(e) => setPostor(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formEventTitle">
              <Form.Label>
                <small className="text-black">Enter branch address</small>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter branch address"
                value={address}
                style={{ borderRadius: 0 }}
                onChange={(e) => setAddress(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formEventTitle">
              <Form.Label>
                <small className="text-black">Enter branch contact cell</small>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter branch cell"
                value={contact}
                style={{ borderRadius: 0 }}
                onChange={(e) => setContact(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {loading ? (
            <img
              src={Loader}
              alt="QR Code"
              width={"100"}
              height={"100"}
              className="img-fluid"
            />
          ) : (
            <Button
              onClick={handleSave}
              style={{
                borderRadius: 0,
                backgroundColor: "#3bc0c3",
                borderWidth: 1,
                borderColor: "#3bc0c3",
              }}
            >
              Save Event
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default Branches;
